import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Divider,
  Collapse,
  Button,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import useStyles from "./style";
import CustomTooltip from "../../../../CohortParticular/tooltip";
import swal from "sweetalert";
import api from "../../../../common/dependencies/utils/Api";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import privateCohortBtn from "../../../../../assets/svg/shield2.svg";
import starIcon from "../../../../../assets/svg/starAbout2.svg";
import copyButton from "../../../../../assets/svg/copyLink.svg";
import moment from "moment";
import ModalFilters from "../../../../CohortParticular/modalFilters";
import clsx from "clsx";
import { withRouter, useHistory, useParams, Link } from "react-router-dom";
import { connect } from "react-redux";
import ModalFilter2 from "../../../../common/modalFilter2";
import shareRounded from "../../../../AdminModule/Dashboard/MentorDashboard/MentorHome/img/share-round.svg";
import {
  COHORT_PARTICULAR,
  VIEW_STARTUP_APPLICATION_DATA,
  ADMIN_DASHBOARD_SPOTLIGHT_CALENDAR,
  GET_MENTOR_MODULE_COHORT_LIST,
  COHORT_USER_EXIT_REQUEST,
  COHORT_CLOSE_REQUEST,
  COHORT_USER_SEND_REQUEST,
} from "../../../../common/constants/ApplicationUrl";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
import {
  postMentorModuleCohort,
  postMentorModuleStartupCohort,
} from "../dependencies/action";
const AboutPage = (props) => {
  const {
    getTotalMentorsPaginate,
    getTotalMentorsData,
    getTotalStartupData,
    postMentorModuleCohort,
    postMentorModuleStartupCohort,
    commonCohortId,
    setCommonCohortId,
    userStatus,
    setReloadFn,
  } = props;
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }

    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };

    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  let value2 = localStorage.getItem("SavedLoggedInData");
  let LoginData = JSON.parse(value2);
  const [data, setData] = useState();
  const [toggleText, setToggleText] = useState(false);
  const [iconsCollapse, setIconsCollapse] = useState(false);
  const [datavaribale, setdatavaribale] = useState("pending");
  const [modalVisibility, setModalVisibility] = useState(false);
  const [loginData, setLoginData] = useState();
  const [isParentData, setIsParentData] = useState("");
  const [viewApplicationData, setViewApplicationData] = useState("");
  const [calendarUpcoming, setCalendarUpcoming] = useState("");
  let presentTime = moment(new Date()).format("DD-MM-YYYY");
  let currentMonth = moment().format("MM");
  const [sessionDate, setSessionDate] = useState("");
  const [sessionMonth, setSessionMonth] = useState("");
  const [modalVisibility2, setModalVisibility2] = useState();
  const [cohortRedirection, setCohortRedirection] = useState("");

  let presentUrl = window.location.href;
  // let sessionDate = moment(ternaryValue).format("DD-MM-YYYY");
  const LoginRole =
    localStorage.getItem("SavedLoggedInData") &&
    JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  const value =
    localStorage.getItem("SavedLoggedInData") &&
    JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const classes = useStyles();
  const history = useHistory();
  const clickedOnBack = () => {
    history.goBack();
  };
  const params = useParams();
  useEffect(() => {
    const LoginRole =
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData"));
    setLoginData(LoginRole);
    setCohortRedirection("");
    setTimeout(() => {
      localStorage.removeItem("allMentorList");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allMentorships");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("mentorMenu");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("startUpApplications");
      localStorage.removeItem("cohortApplication");
      localStorage.removeItem("CohortStartupRequest");
    }, 1000);
  }, []);

  useEffect(() => {
    loadFn();
  }, [commonCohortId]);
  const loadFn = () => {
    let paramData;
    let testID;
    if (
      commonCohortId !== undefined &&
      commonCohortId !== null &&
      commonCohortId !== ""
    ) {
      testID = commonCohortId;
    } else {
      testID = params.cohortId;
    }
    const LoginRole =
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
    if (LoginRole === "Mentor" || LoginRole === "Admin") {
      paramData = {
        id: testID,
        mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      };
    } else if (LoginRole === "Startup") {
      paramData = {
        id: testID,
        startupId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      };
    } else {
      paramData = {
        id: testID,
      };
    }
    // axios({
    //   url: COHORT_PARTICULAR,
    //   method: "post",
    //   data: paramData,
    // })

    api
      .POST(COHORT_PARTICULAR, paramData)
      .then((res) => {
        setData(res.data?.data);
        props?.setHeadingCohort(res?.data?.data?.program_name);
        props?.setIsParentData(res?.data?.data);
        setSessionDate(
          moment(res?.data?.data?.cohort_date).format("DD-MM-YYYY")
        );
        setSessionMonth(moment(res?.data?.data?.cohort_date).format("MM"));
      })
      .catch((err) => {});
  };
  //   useEffect(() => {
  //     history.listen((location) => {
  //         console.log(`You changed the page to: ${location.pathname}`)
  //     })
  // }, [history])
  useEffect(() => {
    // const params = { id: props.location.state };

    loadApplication();
  }, []);
  const loadApplication = () => {
    api
      .POST(`${VIEW_STARTUP_APPLICATION_DATA}`, { id: value?.dippNumber })
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (response.data.data) setViewApplicationData(response.data.data);
        } else {
        }
      })
      .catch((e) => {});
  };
  useEffect(() => {
    // or you can use `.format`:
    if (data !== undefined && data !== null && data !== "") {
      var localTime = new Date(); // store localTime
      let localFullTime = localTime.toISOString();
      var proposedDate = localTime + "T00:00:00.000Z";
      var momentDate = moment(proposedDate);
      var endMonth = moment(localTime).add(30, "day").toDate();
      var endMonth2 = endMonth.toISOString();
      var hour = momentDate.hours();
      var minutes = momentDate.minutes();
      var seconds = momentDate.seconds();
      let paramsTest = {
        cohortId: data?.cohortId,
        sessionStartDate: localFullTime,
        sessionEndDate: endMonth2,
      };
      api
        .POST(`${ADMIN_DASHBOARD_SPOTLIGHT_CALENDAR}`, paramsTest)
        .then((response) => {
          const { data, status } = response || {};
          if (status === 200) {
            if (response.data.data?.length > 0)
              setCalendarUpcoming(response.data.data);
          } else {
          }
        })
        .catch((e) => {});
      getCohortMentorFunction();
      getCohortStartupFunction();
      getCohortPendingMentorFunction();
    }
  }, [data]);
  // useEffect(() => {
  // console.log("viewApplicationData",viewApplicationData)
  // }, [viewApplicationData])
  useEffect(() => {
    if (toggleText) {
      setTimeout(() => {
        setToggleText(false);
      }, 80000);
    }
  }, [toggleText]);
  const ViewProfile = (item, id) => {
    const currentRoute = window.location.href;
    let sample;
    sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
    let reRoute = window.open(
      `/mentor-profile/${encryptAES2(item, PROFILE_KEY)}`,
      "_blank"
    );
  };
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
    //   CryptoJS.enc.Hex
    // );

    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);

    // let aesText = iv + "::" + salt + "::" + ciphertext;

    return btoa(text);
  };
  useEffect(() => {
    if (
      calendarUpcoming !== undefined &&
      calendarUpcoming !== "" &&
      calendarUpcoming !== null &&
      calendarUpcoming?.length > 0
    ) {
      let arr = [];

      calendarUpcoming.forEach((element) => {
        if (element?.sessionStatus !== "CANCELLED")
          arr.push({
            date: moment(element?.sessionDate).format("YYYY/MM/DD"),
            cohortId: element?.cohortId,
            cohortAdminId: element?.cohortAdminId,
          });
      });
      let nearestDate;
      let nearestDate2;
      const dateToCheckFor = moment().format("YYYY/MM/DD");
      arr.forEach((element) => {
        // let diff = moment(element?.date).diff(moment(dateToCheckFor), "days");
        // if (diff > 0) {
        if (nearestDate) {
          if (moment(element?.date).diff(moment(nearestDate), "days") < 0) {
            nearestDate = element?.date;
            nearestDate2 = element;
          }
        } else {
          nearestDate = element?.date;
          nearestDate2 = element;
        }
        // }
      });
      if (
        nearestDate !== undefined &&
        nearestDate !== null &&
        nearestDate !== ""
      ) {
        setCohortRedirection(nearestDate2);
      }
    }
  }, [calendarUpcoming]);
  const getCohortMentorFunction = () => {
    let params = {
      cohortAdminId: data?.cohort?.cohortAdminId,
      industry: "",
      function: "",
      stage: "",
      cohortId: data?.cohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 5,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      requestStatus: "Accepted",
    };
    postMentorModuleCohort(params);
  };
  const getCohortStartupFunction = () => {
    let params = {
      cohortAdminId: data?.cohort?.cohortAdminId,
      industry: "",
      function: "",
      stage: "",
      cohortId: data?.cohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      requestStatus: "Requested",
    };
    postMentorModuleStartupCohort(params);
  };
  const getCohortPendingMentorFunction = () => {
    let params = {
      cohortAdminId: data?.cohort?.cohortAdminId,
      industry: "",
      function: "",
      stage: "",
      cohortId: data?.cohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      requestStatus: "Requested",
    };
    api
      .POST(GET_MENTOR_MODULE_COHORT_LIST, params)
      .then((res) => {
        let incomingData = res?.data?.data;
        if (
          incomingData !== undefined &&
          incomingData !== "" &&
          incomingData !== null &&
          incomingData?.length > 0
        ) {
          props?.setMentorMarker(true);
        } else {
          props?.setMentorMarker(false);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (
      getTotalStartupData !== undefined &&
      getTotalStartupData !== "" &&
      getTotalStartupData !== null &&
      getTotalStartupData?.length > 0
    ) {
      props?.setStartupMarker(true);
    } else {
      props?.setStartupMarker(false);
    }
  }, [getTotalStartupData]);
  const exitCohort = () => {
    swal("Are you sure?", "Do you want to exit this cohort?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    })
      .then((value) => {
        if (value === "delete") {
          exitapiCall();
        } else {
          swal("Exit cohort operation cancelled");
        }
      })

      .catch((err) => {});
  };
  const exitapiCall = () => {
    api
      .POST(`${COHORT_USER_EXIT_REQUEST}`, { cohortId: data?.cohortId })
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          swal("Success", "You exited the Cohort Successfully!", "success");
          setTimeout(() => {
            if (loginData?.role == "Startup") {
              localStorage.setItem(
                "MyCohortStartupDashboard",
                "MyCohortStartupDashboard"
              );
              history.push("/dashboard");
            } else {
              localStorage.setItem(
                "MyCohortMentorDashboard",
                "MyCohortMentorDashboard"
              );
              history.push({
                pathname: `/dashboard`,
                state: "cohortForm",
              });
            }
          }, 3000);
        } else {
        }
      })
      .catch((e) => {});
  };
  const closeAPICall = () => {
    api
      .POST(`${COHORT_CLOSE_REQUEST}`, { cohortId: data?.cohortId })
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          swal("Success", "Successfully Closed the Cohort.", "success");
          setTimeout(() => {
            localStorage.setItem(
              "MyCohortMentorDashboard",
              "MyCohortMentorDashboard"
            );
            history.push({
              pathname: `/dashboard`,
              state: "cohortForm",
            });
          }, 3000);
        } else {
          swal("Info", "Server error, please try again later.", "info");
        }
      })
      .catch((e) => {});
  };
  const handlePublicJoin = () => {
    api
      .POST(COHORT_USER_SEND_REQUEST, {
        // mentorId: value?.id,
        cohortId: data?.cohortId,
        intentToMentor: "",
        cohortType: "public",
      })
      .then((res) => {
        if (res?.data?.success)
          swal("Success", "Your Request Sent Successfully!", "success");
        else
          swal(
            "Info",
            "Server error, please try again after some time.",
            "info"
          );
        // swal("Success", "You joined the Cohort Successfully!", "success");
        setTimeout(() => {
          loadApplication();
          loadFn();
          setReloadFn(true);
        }, 1000);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    loadFn();
  }, [datavaribale]);
  return (
    <Box
      className={classes.root}
      // style={{marginTop:"8rem"}}
    >
      <ModalFilters
        cohortId={data?.cohortId}
        sendToParent={setIsParentData}
        modalVisibility={modalVisibility}
        setModalVisibility={setModalVisibility}
        fromModule="allMentorsList"
        viewApplicationData={viewApplicationData}
      />
      {/* <img className="newCohortImgBtn2" src={privateCohortBtn} /> */}
      <div className="d-flex">
        <div style={{ width: "50%" }}>
          <div style={{ width: "98%" }}>
            <div className="aboutCohortHeading">{data?.program_name}</div>
            <div className="aboutCohortDescription">{data?.program_desc}</div>
          </div>
        </div>
        <div style={{ width: "50%" }}>
          <Box
          // style={{
          //     height: "440px",
          //     width: "790px",
          //   }}
          >
            <img
              src={data?.uploadBanner || hashImage}
              className={classes.imageMain}
            />
          </Box>
        </div>
      </div>
      <div>
        <div
          className={
            data !== undefined && data?.program_desc?.length > 878
              ? "d-flex mt-4"
              : "d-flex mt-2"
          }
        >
          <div className=" cohortSessionContentItem">
            Start Date:
            {data?.cohort_date ? (
              <span className="cohortSessionContentItem2">
                {" "}
                {moment(data?.cohort_date).format("DD/MM/YYYY")}
              </span>
            ) : (
              ""
            )}
          </div>
          {/* <div className="cohortSessionContentItem">
            End Date:
            {data?.cohort_date ? (
              <span className="cohortSessionContentItem2">
                {" "}
                {moment(data?.cohort?.cohortEnd).format("DD/MM/YYYY")}
              </span>
            ) : (
              ""
            )}
          </div> */}
        </div>

        {data?.program_duration !== undefined &&
          data?.program_duration !== null && (
            <div className="d-flex mt-2">
              <div className="cohortSessionContentItem">
                Duration:
                {data?.infiniteDuration ? (
                  <span className="cohortSessionContentItem2">
                    {" "}
                    No end date
                  </span>
                ) : (
                  <span className="cohortSessionContentItem2">
                    {" "}
                    {data?.program_duration} Months
                  </span>
                )}
              </div>
            </div>
          )}

        {data?.cohort?.cohortStatus !== undefined &&
          data?.cohort?.cohortStatus !== "CLOSED" && (
            <div className="d-flex">
              <div className="d-flex" style={{ width: "50%" }}>
                {(data?.requestStatus == "Accepted" ||
                  data?.cohort?.cohortAdminId == value?.id ||
                  value?.role == "Admin") && (
                  <div
                    className="d-flex newAboutExitBtn top-btn"
                    onClick={() => {
                      if (data?.cohort?.cohortAdminId == value?.id || loginData?.role == "Admin") {
                        // if (
                        //   (LoginRole === "Mentor" &&
                        //     value?.applicationStatus === "VERIFIED" &&
                        //     data?.cohort?.cohortStatus !== "CLOSED") ||
                        //   (loginData?.role === "Startup" &&
                        //     loginData?.applicationStatus === "SUBMITTED" &&
                        //     data?.cohort?.cohortStatus !== "CLOSED")
                        // ) {
                        //   setModalVisibility(true);
                        // }
                        // swal("Are you sure?", "Do you want to Close this cohort?", {
                        //   icon: "warning",
                        //   buttons: {
                        //     delete: {
                        //       text: "OK",
                        //     },
                        //     decline: {
                        //       text: "CANCEL",
                        //     },
                        //   },
                        // }).then((value) => {
                        //   if (value === "delete") {
                        //     swal("Successfully Closed the cohort.");
                        //     // deleteapiCall();
                        //   } else {
                        //     swal("Close operation cancelled.");
                        //   }
                        // });
                        history.push({
                          pathname: `/cohort-form`,
                          state: {
                            data: data,
                            mode: "edit",
                            fromPage: "aboutPage",
                          },
                        });
                      } else {
                        exitCohort();
                      }
                    }}
                  >
                    {data?.cohort?.cohortAdminId == loginData?.id ||
                    value?.role == "Admin"
                      ? "Edit Cohort"
                      : "Exit Cohort"}
                    {/* {data?.applied === false ? "Edit Cohort" : "Exit Cohort"} */}
                  </div>
                )}
                {data?.applied == false &&
                data?.cohortVisibility &&
                data?.cohort?.cohortAdminId !== value?.id &&
                value?.role !== "Admin" ? (
                  <>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#644b9f",
                        color: "white",
                        fontFamily: "Montserrat",
                        padding: "0px 30px",
                        borderRadius: "20px",
                        marginTop: "30px",
                        whiteSpace: "nowrap",
                        height: "fit-content",
                        minWidth: "8rem",
                        marginRight: "10px",
                      }}
                      onClick={() => {
                        handlePublicJoin();
                      }}
                    >
                      JOIN NOW
                    </Button>
                  </>
                ) : (
                  data?.applied == false &&
                  !data?.cohortVisibility &&
                  data?.cohort?.cohortAdminId !== value?.id &&
                  value?.role != "Admin" && (
                    <CustomTooltip
                      fromModule="CohortParticular"
                      isPurpose={false}
                      cohortData={data}
                      isRequestSent={datavaribale}
                      change={setdatavaribale}
                    >
                      <div className="newuserTooltip top-btn">
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "#644b9f",
                            color: "white",
                            fontFamily: "Montserrat",
                            padding: "0px 30px",
                            borderRadius: "20px",
                            marginTop: "30px",
                          }}
                        >
                          APPLY NOW
                        </Button>
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{ left: "90px", top: "52px", width: "130px" }}
                        >
                          Click to Apply
                        </span>
                      </div>
                    </CustomTooltip>
                  )
                )}
                {data?.applied == true &&
                  data?.requestStatus !== "Accepted" &&
                  data?.cohort?.cohortAdminId !== value?.id && (
                    <div className="newuserTooltip top-btn">
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#644b9f",
                          color: "white",
                          fontFamily: "Montserrat",
                          padding: "0px 30px",
                          borderRadius: "20px",
                          marginTop: "30px",
                        }}
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                      >
                        Applied
                      </Button>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "43px", top: "52px", width: "190px" }}
                      >
                        You Have Already Applied
                      </span>
                    </div>
                  )}
                {data?.cohort?.cohortStatus !== undefined &&
                  data?.cohort?.cohortStatus !== "CLOSED" &&
                  (data?.cohort?.cohortAdminId == value?.id ||
                    LoginRole == "Admin") && (
                    <div
                      className="d-flex newAboutExitBtn top-btn"
                      onClick={() => {
                        swal(
                          "Warning",
                          "Do you want to close the Cohort, this action can not be reversed.",
                          // "Do you want to close the Cohort, this action can not be reversed",
                          {
                            icon: "warning",
                            buttons: {
                              delete: {
                                text: "OK",
                              },
                              decline: {
                                text: "CANCEL",
                              },
                            },
                          }
                        ).then((value) => {
                          if (value === "delete") {
                            closeAPICall();
                            // swal("Successfully Closed the cohort.");
                            // deleteapiCall();
                          } else {
                            swal("Close operation cancelled.");
                          }
                        });
                      }}
                    >
                      Close Cohort{" "}
                    </div>
                  )}

                {cohortRedirection !== null &&
                  cohortRedirection !== "" &&
                  cohortRedirection !== undefined &&
                  (data?.requestStatus == "Accepted" ||
                    data?.cohortVisibility ||
                    data?.cohort?.cohortAdminId == value?.id ||
                    value?.role == "Admin") && (
                    <div className="newAboutExitBtnDisabled2">
                      Next Session:{" "}
                      {moment(cohortRedirection?.date).format("DD/MM/YYYY")}
                    </div>
                  )}
                {(data?.requestStatus == "Accepted" ||
                  data?.cohortVisibility ||
                  data?.cohort?.cohortAdminId == value?.id ||
                  value?.role == "Admin") && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      width: "100%",
                      marginTop: "2.5%",
                    }}
                  >
                    <div
                      className="dashboard-bottom-btn top-btn  newuserTooltip "
                      onClick={() => setModalVisibility2(true)}
                    >
                      <p
                        style={{ cursor: "pointer", color: "white" }}
                        className="createcohortsessionbtnpara"
                      >
                        COHORTS EVENTS CALENDAR
                      </p>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "150px", top: "60px", width: "250px" }}
                      >
                        Click to View Cohorts Event Calendar
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <div
                className="d-flex mt-1"
                style={{ width: "50%", justifyContent: "flex-end" }}
              >
                <div className="shareCohortDetails w-100">
                  <div
                    style={{
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                    onMouseEnter={() => setIconsCollapse(true)}
                    onMouseLeave={() => setIconsCollapse(false)}
                    className="mentorshare"
                  >
                    <img
                      src={shareRounded}
                      style={{
                        height: "40px",
                        width: "40px",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                    />
                    <Collapse in={iconsCollapse}>
                      <Tooltip
                        classes={{
                          tooltip: classes.tooltip,
                          tooltipArrow: classes.tooltipArrow,
                        }}
                        PopperProps={{
                          disablePortal: true,
                        }}
                        arrow
                        title={
                          <Typography
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              color: "#fff",
                              fontWeight: "bold",
                            }}
                          >
                            Share on Whatsapp
                          </Typography>
                        }
                      >
                        <WhatsappShareButton
                          url={presentUrl}
                          style={{
                            height: "35px",
                            width: "35px",
                            borderRadius: "50%",
                          }}
                        >
                          <WhatsappIcon
                            style={{
                              height: "35px",
                              width: "35px",
                              borderRadius: "50%",
                            }}
                          />
                        </WhatsappShareButton>
                      </Tooltip>
                      <Tooltip
                        classes={{
                          tooltip: classes.tooltip,
                          tooltipArrow: classes.tooltipArrow,
                        }}
                        PopperProps={{
                          disablePortal: true,
                        }}
                        arrow
                        title={
                          <Typography
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              color: "#fff",
                              fontWeight: "bold",
                            }}
                          >
                            Share on Facebook
                          </Typography>
                        }
                      >
                        <FacebookShareButton
                          url={presentUrl}
                          style={{
                            height: "35px",
                            width: "35px",
                            borderRadius: "50%",
                          }}
                        >
                          <FacebookIcon
                            style={{
                              height: "35px",
                              width: "35px",
                              borderRadius: "50%",
                              marginLeft: "12%",
                            }}
                          />
                        </FacebookShareButton>
                      </Tooltip>
                      {/* <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Share on Linkedin
                              </Typography>
                            }
                          >
                            <LinkedinShareButton
                              url={presentUrl}
                              style={{
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                                marginLeft: "10px",
                              }}
                            >
                              <LinkedinIcon
                                style={{
                                  height: "35px",
                                  width: "35px",
                                  borderRadius: "50%",
                                }}
                              />
                            </LinkedinShareButton>
                          </Tooltip> */}
                      <Tooltip
                        classes={{
                          tooltip: classes.tooltip,
                          tooltipArrow: classes.tooltipArrow,
                        }}
                        PopperProps={{
                          disablePortal: true,
                        }}
                        arrow
                        title={
                          <Typography
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              color: "#fff",
                              fontWeight: "bold",
                            }}
                          >
                            Share on Twitter
                          </Typography>
                        }
                      >
                        <TwitterShareButton
                          url={presentUrl}
                          style={{
                            height: "35px",
                            width: "35px",
                            borderRadius: "50%",
                            marginLeft: "10px",
                          }}
                        >
                          <TwitterIcon
                            style={{
                              height: "35px",
                              width: "35px",
                              borderRadius: "50%",
                            }}
                          />
                        </TwitterShareButton>
                      </Tooltip>
                      <Tooltip
                        classes={{
                          tooltip: classes.tooltip,
                          tooltipArrow: classes.tooltipArrow,
                        }}
                        PopperProps={{
                          disablePortal: true,
                        }}
                        arrow
                        title={
                          <Typography
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              color: "#fff",
                              fontWeight: "bold",
                            }}
                          >
                            {toggleText
                              ? "URL copied to clipboard"
                              : "Copy to clipboard"}
                          </Typography>
                        }
                      >
                        <TwitterShareButton
                          onClick={() => {
                            setToggleText(!toggleText);
                            navigator.clipboard.writeText(presentUrl);
                          }}
                        >
                          <div
                            style={{
                              height: "21px",
                              width: "30px",
                              borderRadius: "50%",
                              marginLeft: "10px",
                            }}
                            onClick={() => {
                              setToggleText(!toggleText);
                              navigator.clipboard.writeText(presentUrl);
                            }}
                          >
                            <img
                              src={copyButton}
                              onClick={() => {
                                setToggleText(!toggleText);
                                navigator.clipboard.writeText(presentUrl);
                              }}

                              //  style={{position:"relative",top:"10px"}}
                            />
                          </div>
                        </TwitterShareButton>
                      </Tooltip>
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>

      {modalVisibility2 && (
        <ModalFilter2
          modalVisibility={modalVisibility2}
          setModalVisibility={setModalVisibility2}
          // sendToParent={setIsParentData}
          showPurposeOfMentorship={true}
          fromPage={"startUpDashboard"}
          allCalendarData={true}
          particularCohort={data?.cohortId}
        />
      )}

      <Typography
        className={clsx("homepageFirstHeader", "mobileHeadingxx", "togglediv2")}
      >
        {" "}
        {data?.program_name}
      </Typography>

      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Paper
            elevation={2}
            style={{
              marginTop: "30px",
              marginRight: "0px",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            {data?.cohort?.cohortStatus !== undefined &&
              data?.cohort?.cohortStatus == "CLOSED" && (
                <div class="d-flex justify-content-end fixedMessageSticky">
                  <div
                    class="fixedMessageStickyText2"
                    style={{ fontSize: "1.25rem" }}
                  >
                    This Cohort is Closed
                  </div>
                </div>
              )}
            <div className="d-flex">
              <div className="d-flex">
                {!data?.cohortVisibility && (
                  <div className="newuserTooltip">
                    <img
                      className="privateButtonIconAbout"
                      src={privateCohortBtn}
                    />
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "8px",
                        width: "160px",
                        height: "30px",
                        top: "4rem",
                      }}
                    >
                      Private Cohort
                    </span>
                  </div>
                )}

                {data?.spotlight !== undefined &&
                  data?.spotlight !== "" &&
                  data?.spotlight !== null &&
                  data?.spotlight && (
                    <div className="goldStarIcon">
                      <img src={starIcon} />
                    </div>
                  )}
              </div>
              <Typography
                className={clsx(classes.heading5, "homepageFirstHeader")}
              >
                Cohort Details
              </Typography>
            </div>
            <div className="d-flex">
              <div style={{ width: "50%" }}>
                <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "40%" }}>
                    Organization Name:
                  </div>
                  <div className="d-flex" style={{ width: "60%" }}>
                    {" "}
                    {data?.cohort?.organization_name}{" "}
                  </div>
                </div>
                <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "40%" }}>
                    {" "}
                    Organization Type:
                  </div>
                  <div className="d-flex" style={{ width: "60%" }}>
                    {" "}
                    {data?.organization_type}{" "}
                  </div>
                </div>
                {/* <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "60%" }}>
                    Application Start day for Startups:
                  </div>
                  <div className="d-flex" style={{ width: "40%" }}>
                    {" "}
                    {data?.startup_start_date !== undefined &&
                    data?.startup_start_date !== null &&
                    data?.startup_start_date !== "" ? (
                      <>
                        {" "}
                        {moment(data?.startup_start_date).format(
                          "Do MMMM YYYY"
                        )}
                      </>
                    ) : (
                      ""
                    )}{" "}
                  </div>
                </div>
                <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "60%" }}>
                    Application End day for Startups:
                  </div>
                  <div className="d-flex" style={{ width: "40%" }}>
                    {" "}
                    {data?.startup_end_date !== undefined &&
                    data?.startup_end_date !== null &&
                    data?.startup_end_date !== "" ? (
                      <>
                        {" "}
                        {moment(data?.cohort?.startup_end_date).format("DD/MM/YYYY")}
                      </>
                    ) : (
                      ""
                    )}{" "}
                  </div>
                </div> */}
                <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "40%" }}>
                    {/* No.of Mentors (Proposed): */}
                    Mentors:
                  </div>
                  <div className="d-flex" style={{ width: "60%" }}>
                    {" "}
                    {data?.numberofmentors == "" ||
                    data?.numberofmentors == null ||
                    data?.numberofmentors == undefined
                      ? "NA"
                      : data?.numberofmentors}
                  </div>
                </div>
                <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "40%" }}>
                    {/* No.of Startups for each mentors: */}
                    Startups:
                  </div>
                  <div className="d-flex" style={{ width: "60%" }}>
                    {" "}
                    {data?.numberofstartups == "" ||
                    data?.numberofstartups == null ||
                    data?.numberofstartups == undefined
                      ? "NA"
                      : data?.numberofstartups}
                  </div>
                </div>
                {/* <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "60%" }}>
                    Startup Stage:
                  </div>
                  <div className="d-flex" style={{ width: "40%" }}>
                    {" "}
                    {data?.preferred_stage[0]}{" "}
                  </div>
                </div> */}
                {/* <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "60%" }}>
                    Avg. mentorship hours per week:
                  </div>
                  <div className="d-flex" style={{ width: "40%" }}>
                    {" "}
                    {data?.hoursperweek}{" "}
                  </div>
                </div> */}

                <div className="aboutDataText d-flex">
                  <div className="d-flex" style={{ width: "40%" }}>
                    Cohort Admin:
                  </div>
                  <div
                    className="d-flex newuserTooltip d-flex sessionListMentor"
                    style={{ width: "60%" }}
                    onClick={() => {
                      ViewProfile(data?.mentorId, data?.id);
                    }}
                  >
                    {" "}
                    {data?.cohort?.cohortAdminName}{" "}
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{
                        left: "1rem",
                        top: "2.5rem",
                        width: "220px",
                      }}
                    >
                      Click to view Cohort Admin
                    </span>
                  </div>
                </div>
                <div className="aboutDataText d-flex" />

                {/* <Typography
              className={clsx(classes.paragraph3, "homepageFirstDescription")}
            >
              Organization Name: {data?.cohort.organization_name}
            </Typography> */}
              </div>
              <div style={{ width: "50%" }}>
                <div
                  style={{
                    borderLeft: "1.5px solid rgb(129, 106, 175)",
                    height: "80%",
                  }}
                >
                  <div
                    className="aboutDataText2 aboutRightCorner"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div>Industry:</div>
                    <div>
                      {data?.industry.map((item, index) => {
                        return (
                          <span className="cohortSessionContentItem2">
                            {item}
                            {data?.industry?.length - 1 > index && ", "}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    className="aboutDataText2 aboutRightCorner"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div>Specialisation:</div>
                    <div>
                      {data?.specialization.map((item, index) => {
                        return (
                          <span className="cohortSessionContentItem2">
                            {item}
                            {data?.specialization?.length - 1 > index && ", "}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    className="aboutDataText2 aboutRightCorner"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    {getTotalMentorsData !== undefined &&
                      getTotalMentorsData !== "" &&
                      getTotalMentorsData !== null &&
                      getTotalMentorsData?.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>Mentors:</div>
                        </div>
                      )}

                    <div
                      className="d-flex mt-2"
                      style={
                        getTotalMentorsData !== undefined &&
                        getTotalMentorsData !== "" &&
                        getTotalMentorsData !== null &&
                        getTotalMentorsData?.length < 3
                          ? { justifyContent: "left", gap: "3rem" }
                          : { justifyContent: "space-around" }
                      }
                    >
                      {getTotalMentorsData !== undefined &&
                        getTotalMentorsData !== "" &&
                        getTotalMentorsData !== null &&
                        getTotalMentorsData?.length > 0 &&
                        getTotalMentorsData.map((item, index) => {
                          return (
                            <div
                              className="newuserTooltip top-btn"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                ViewProfile(item?.mentor?.email);
                              }}
                            >
                              <img
                                className="cohortMentorInvitedAbout"
                                src={
                                  item?.mentor?.image !== undefined &&
                                  item?.mentor?.image !== "" &&
                                  item?.mentor?.image !== null
                                    ? item?.mentor?.image
                                    : hashImage
                                }
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "2.5rem",
                                  top: "8 rem",
                                  width: "150px",
                                }}
                              >
                                Click to view Mentor
                              </span>
                            </div>
                          );
                        })}
                    </div>
                    <div
                      className="w-100 d-flex  mt-4"
                      style={{ justifyContent: "center" }}
                    >
                      <div
                        className="newAboutExitBtn newuserTooltip top-btn"
                        style={{ marginTop: "0" }}
                        onClick={() => {
                          props?.setSelectedNavigation(3);
                        }}
                      >
                        {" "}
                        View All Mentors
                        <span
                          className="tooltiptext tooltip-bottom "
                          style={{
                            left: "5.5rem",
                            top: "3rem",
                            width: "150px",
                          }}
                        >
                          View All Mentors
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Paper>

          {/* <CohortTable data={data} /> */}
        </Grid>

        {/* <Paper
            elevation={2}
            style={{
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <img
              src={data?.uploadLogo || hashImage}
              style={{
                height: "170px",
                width: "170px",
                objectFit: "contain",
                maxHeight: "none",
                maxWidth: "none",
                borderRadius: "10px",
                marign: "auto",
              }}
              className={classes.image}
            />

           
          </Paper> */}
        {/* {loginData?.role === "Startup" &&
            loginData?.applicationStatus === "SUBMITTED" &&
            data?.cohort?.cohortStatus !== "CLOSED" && (
              <Paper
                elevation={2}
                style={{
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "20px",
                  marginTop: "30px",
                }}
              >
                <Typography
                  className={clsx(classes.heading5, "homepageFirstDescription")}
                >
                  FOR STARTUPS
                </Typography>
                <Typography
                  className={clsx(classes.heading3, "homepageFirstDescription")}
                >
                  Application Start Date
                </Typography>
                <Box className={clsx(classes.box2, "homepageFirstDescription")}>
                  {data?.startup_start_date
                    ? moment(data?.startup_start_date).format("Do MMMM YYYY")
                    : ""}
                </Box>
                <Typography
                  className={clsx(classes.heading3, "homepageFirstDescription")}
                >
                  Application End Date
                </Typography>
                <Box className={clsx(classes.box2, "homepageFirstDescription")}>
                  {data?.startup_end_date
                    ? moment(data?.startup_end_date).format("Do MMMM YYYY")
                    : ""}
                </Box>
                <div className="newuserTooltip top-btn">
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#644b9f",
                      color: "white",
                      fontFamily: "Montserrat",
                      padding: "0px 30px",
                      borderRadius: "20px",
                      marginTop: "20px",
                    }}
                    onClick={() =>
                      data?.applied === false ? setModalVisibility(true) : ""
                    }
                  >
                    {data?.applied === false ? "JOIN" : "Applied"}
                  </Button>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "43px", top: "52px", width: "190px" }}
                  >
                    {data?.applied === false
                      ? " Click to Join Cohort"
                      : "You Have Already Applied"}
                  </span>
                </div>
              </Paper>
            )}
          {(currentMonth > sessionMonth ||
            (currentMonth == sessionMonth && presentTime > sessionDate)) && (
            <Paper
              elevation={2}
              style={{
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "20px",
                marginTop: "30px",
              }}
            >
              <Typography
                className={clsx(classes.heading5, "homepageFirstDescription")}
              >
                COHORT MEMBERS
              </Typography>
           
              <div className="cohortNewBox">
                <div>Total Members:</div>
                <div>
                  {Number(data?.numberofmentors) +
                    Number(data?.numberofstartups)}
                </div>
              </div>
             
              <div className="cohortNewBox">
                <div>Startups:</div>
                <div>{data?.numberofstartups}</div>
              </div>
           
              <div className="cohortNewBox">
                <div>Mentors:</div>
                <div>{data?.numberofmentors}</div>
              </div>
            </Paper>
          )} */}

        {/* {LoginRole === "Mentor" &&
            value?.applicationStatus === "VERIFIED" &&
            data?.cohort?.cohortStatus !== "CLOSED" &&
            (value?.id !== data?.mentorId ? (
              <Paper
                elevation={2}
                style={{
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "20px",
                  marginTop: "30px",
                }}
              >
                <Typography
                  className={clsx(classes.heading2, "homepageFirstDescription")}
                >
                  FOR MENTORS
                </Typography>
                <Box className={clsx(classes.box3, "homepageFirstDescription")}>
                  Interested to become a Mentor on this COHORT program?
                </Box>
                {data?.applied === false ? (
                  <CustomTooltip
                    fromModule="CohortParticular"
                    isPurpose={false}
                    cohortData={data}
                    isRequestSent={datavaribale}
                    change={setdatavaribale}
                  >
                    <div className="newuserTooltip top-btn">
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#644b9f",
                          color: "white",
                          fontFamily: "Montserrat",
                          padding: "0px 30px",
                          borderRadius: "20px",
                          marginTop: "20px",
                        }}
                      >
                        APPLY NOW
                      </Button>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "52px", width: "130px" }}
                      >
                        Click to Apply
                      </span>
                    </div>
                  </CustomTooltip>
                ) : (
                  <div className="newuserTooltip top-btn">
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#644b9f",
                        color: "white",
                        fontFamily: "Montserrat",
                        padding: "0px 30px",
                        borderRadius: "20px",
                        marginTop: "20px",
                      }}
                      disableRipple
                      disableFocusRipple
                      disableTouchRipple
                    >
                      Applied
                    </Button>
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "43px", top: "52px", width: "190px" }}
                    >
                      You Have Already Applied
                    </span>
                  </div>
                )}
              </Paper>
            ) : (
              ""
            ))} */}
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    getTotalMentorsData: state.MentorReducer.getCohortMentorModuleList.data,
    getTotalMentorsPaginate:
      state.MentorReducer.getCohortMentorModuleList.paginate,
    getTotalStartupData:
      state.MentorReducer.getStartupCohortMentorModuleList.data,
    getTotalStartupPaginate:
      state.MentorReducer.getStartupCohortMentorModuleList.paginate,
  };
};

export default connect(mapStateToProps, {
  postMentorModuleCohort,
  postMentorModuleStartupCohort,
})(withRouter(AboutPage));
